/**
 * Application version tracking utility
 * Helps debug caching and deployment issues across environments
 */

// Build timestamp generated at build time
const BUILD_TIMESTAMP = new Date().toISOString();
const BUILD_ID = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;

export const APP_VERSION = {
  name: 'AmeUp',
  build: BUILD_ID,
  timestamp: BUILD_TIMESTAMP,
  environment: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
};

export function logVersion(): void {
  const versionInfo = [
    `🎉 ${APP_VERSION.name} v${APP_VERSION.build}`,
    `📅 Build: ${APP_VERSION.timestamp}`,
    `🌍 Environment: ${APP_VERSION.environment}`,
    `🔧 Mode: ${APP_VERSION.isDev ? 'Development' : 'Production'}`,
  ].join('\n');

  
  // Also log to help with debugging
}

// Expose version globally for debugging in console
if (typeof window !== 'undefined') {
  (window as any).__APP_VERSION__ = APP_VERSION;
}
